import React, { useMemo } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import { getSanitizedPaymentResultSearchParams } from "../../utils/paymentResultSecurity";

const PaymentResult = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = localStorage.getItem("lang") || "az";

  const params = useMemo(
    () => getSanitizedPaymentResultSearchParams(location.search),
    [location.search]
  );

  const paramEntries = useMemo(() => [...params.entries()], [params]);
  const hasParams = paramEntries.length > 0;

  return (
    <div className="container py-5" style={{ maxWidth: 560 }}>
      <Helmet>
        <title>Ödəniş nəticəsi</title>
      </Helmet>

      <h1 className="h4 mb-3">Ödəniş nəticəsi</h1>
      <p className="text-muted small mb-4">
        Bank qayıdışı qəbul edildi. Sifarişinizin statusu sistemdə
        yenilənəcəksə, bir neçə dəqiqə gözləyin.
      </p>

      {hasParams ? (
        <div className="card card-body shadow-sm mb-4">
          <p className="small text-muted mb-2">
            Qayıdış parametrləri ({paramEntries.length})
          </p>
          <dl className="small mb-0">
            {paramEntries.map(([key, value]) => (
              <div key={key} className="row mb-1">
                <dt className="col-sm-4 text-break">{key}</dt>
                <dd className="col-sm-8 text-break">{value}</dd>
              </div>
            ))}
          </dl>
        </div>
      ) : (
        <p className="alert alert-secondary small">
          URL-də əlavə parametr yoxdur; bu, bankın POST ilə göndərməsi və ya
          yalnız səhifə açılması ola bilər.
        </p>
      )}

      <button
        type="button"
        className="btn btn-primary"
        onClick={() => navigate(`/${lang}/`)}
      >
        Ana səhifəyə qayıt
      </button>
    </div>
  );
};

export default PaymentResult;
